import * as React from 'react';
import classnames from 'classnames';
import jsbarcode from 'jsbarcode';
import OPButton from '../op-button';
import OPTag from '../op-tag';
import event from '../event';
import './index.scss';
const Card = ({ className = '', maxHeight = '', title = '', content = '', backgroundColor = '', imgList = [], action = {}, barcode = {}, status = '', tag = {}, infoType = 'warning', infoTitle = '', infoTags = [], infoMessage = '', titleStyle = {}, contentStyle = {}, }) => {
    const defaultBarcodeId = `barcode-${Math.random().toString().slice(-10)}`;
    const { name: actionName, hotkey, onAction } = action;
    const { id: barcodeId = defaultBarcodeId, value: barcodeValue, ...barcodeRest } = barcode;
    // 卡片状态 enable
    const enable = React.useMemo(() => {
        return title || content || imgList?.length || barcodeValue;
    }, [title, content, imgList, barcodeValue]);
    const cardStyle = React.useMemo(() => {
        const newCardStyle = {
            backgroundColor: '',
            maxHeight: '',
        };
        // 卡片背景色
        if (backgroundColor) {
            let bgColor = '';
            switch (backgroundColor) {
                case 'primary': // 重点信息 - 黄色
                    bgColor = '#FFD119';
                    break;
                case 'pm': // 包材信息 - 淡蓝色
                    bgColor = '#D7EAFC';
                    break;
                case 'protection': // 防护信息 - 淡绿色
                    bgColor = '#DAF2DE';
                    break;
                default:
                    bgColor = backgroundColor;
                    break;
            }
            newCardStyle.backgroundColor = bgColor;
        }
        // 卡片最大高
        if (typeof maxHeight === 'string' && maxHeight) {
            newCardStyle.maxHeight = maxHeight;
        }
        return newCardStyle;
    }, [backgroundColor, maxHeight]);
    React.useEffect(() => {
        // 条形码初始化
        if (barcodeValue) {
            document.getElementById(barcodeId) &&
                jsbarcode(`#${barcodeId}`, barcodeValue, {
                    ...barcodeRest,
                });
        }
    }, [barcodeId, barcodeValue, barcodeRest]);
    React.useEffect(() => {
        hotkey && onAction && event.bind(hotkey, onAction);
        return () => {
            hotkey && onAction && event.unbind(hotkey, onAction);
        };
    }, [hotkey, onAction]);
    return enable ? (React.createElement("div", { className: classnames('op-card', status && `op-card-${status}`, {
            'op-card-image': imgList.length || barcodeValue,
            'op-card-max-height': maxHeight,
        }, className), style: cardStyle },
        title ? (React.createElement("div", { className: 'op-card-title', style: titleStyle },
            title,
            tag?.children ? React.createElement(OPTag, { ...tag }, tag.children) : '')) : null,
        content ? (React.createElement("div", { className: classnames('op-card-content', {
                'op-card-scroll': maxHeight,
            }), style: contentStyle }, Array.isArray(content)
            ? content.map((item) => React.createElement("div", null, item))
            : content)) : null,
        imgList?.length ? (React.createElement("div", { className: 'op-card-image-content' }, imgList.map((item) => {
            const { url = '', fit = 'contain-out' } = item;
            return (React.createElement("div", { className: classnames('image-item', `fit-${fit}`) },
                React.createElement("img", { alt: '', src: url })));
        }))) : null,
        barcodeValue ? (React.createElement("div", { className: 'op-card-barcode-content' },
            React.createElement("svg", { id: barcodeId }))) : null,
        infoTitle && (React.createElement("div", { className: `op-card-info op-card-info-${infoType}` },
            React.createElement("div", { className: 'op-card-info-title' },
                React.createElement("span", null, infoTitle)),
            React.createElement("div", { className: 'op-card-info-tags' }, infoTags.map((infoTag) => (React.createElement("div", { className: 'op-card-info-tag' }, infoTag)))),
            React.createElement("div", { className: 'op-card-info-message' }, infoMessage))),
        actionName ? (React.createElement(OPButton, { "data-hottag": 'cn-op.card-action', className: 'op-card-action', type: 'text', hotkey: hotkey, onClick: onAction }, actionName)) : null)) : null;
};
export default Card;
